import {common_utils} from "../common/common_utils";

function game_3008()
{


}
game_3008.describe_message = function(this1)
{
  let message = this1.$t(`lang.str_zj_win_index`)+":";
  for(let i = 0;i<16;i++)
  {
    // message +=  "【"+game_3008.getWinIndex(this1,i)+"】   ";
    message +=  "   "+game_3008.getWinIndex(this1,i)+"   ";
  }
  return message;
}


game_3008.getWinIndex = function(this1,index)
{
    if(common_utils.isNull(index))
    {
      return "";
    }
    let lang_key = `lang.str_3008_describe_message`+index;
    return this1.$t(lang_key);
}

export {
  game_3008
};




// WEBPACK FOOTER //
// ./src/components/esports/game_3008.js